export default "__VITE_ASSET__Db62$_Tx__"